import React, { Component } from 'react';
import "./header.css";
import { NavLink } from "react-router-dom";
import MobileHeader from "./mobileHeader";

export default class Header extends Component {
  constructor(props) {
      super(props);
      this.state = {
        active:false,
        mobileMenuActive:false
      }
  }
  componentDidMount = () =>{
		window.addEventListener("scroll", this.onScroll);
	}
	componentWillUnmount = () =>{
		window.removeEventListener("scroll", this.onScroll);
	}
  toggleMobileMenu = () =>{
    if(this.state.mobileMenuActive){
      this.setState({
        mobileMenuActive:false
      })
    } else{
      this.setState({
        mobileMenuActive:true
      })
    }
  }
	onScroll = (e) => {
		let distance = document.documentElement.scrollTop;
		if(distance == 0){
			distance = document.body.scrollTop;
		}
		if(distance < (80)){
			this.setState({
				active:false
			})
		} else{
			if(!this.state.active){
				this.setState({
					active:true
				})
			}
		}
	}

  render() {
    let activeClass = "";
    if (this.state.active){
      activeClass = "active"
    }
    return (
      <div className={"header-container "+activeClass}>
        <MobileHeader active={this.state.mobileMenuActive} toggleMobileMenu={this.toggleMobileMenu} />
        <NavLink to="/">
          <div className="header-logo"></div>
        </NavLink>
        <div className="header-mobile-menu-icon" onClick={this.toggleMobileMenu}>
          {this.state.active ?
            <img className="full-width subheading" src="/images/menu-black.png" />
            :
            <img className="full-width" src="/images/menu-light.png" />
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/index.js